<template>
  <div
    class="main-ct"
    :style="[
      leftOrientation
        ? { 'background-color': '#fff' }
        : { 'background-color': '#f8fafc' }
    ]"
  >
    <div v-if="!leftOrientation">
      <img
        style="margin-right: 25px;"
        :src="require('@/img/mlstudio/' + imageName + '.svg')"
        :alt="$t(title)"
      />
    </div>
    <div
      class="description-ct"
      :style="[
        leftOrientation
          ? { 'margin-right': '25px;' }
          : { 'margin-left': '25px' }
      ]"
    >
      <p class="heading-paragraph">
        {{ $t(header) }}
      </p>
      <p class="title-paragraph">
        {{ $t(title) }}
      </p>
      <p class="description-paragraph" v-html="$t(description)" />
    </div>
    <div v-if="leftOrientation">
      <img
        style="margin-left: 25px;"
        :src="require('@/img/mlstudio/' + imageName + '.svg')"
        :alt="$t(title)"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'MlStudioTwoColSection',

  props: {
    header: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    imageName: {
      type: String,
      required: true
    },
    leftOrientation: {
      type: Boolean,
      required: false,
      default: true
    }
  }
}
</script>

<style scoped>
.main-ct {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 60px 65px;
  gap: 40px;
  background-color: #f8fafc;
}
.description-ct {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  width: 350px;
}

.heading-paragraph {
  font-size: 16px;
  font-weight: 600;
  color: #176ca1;
}

.title-paragraph {
  color: #5c6374;
  font-size: 24px;
  font-weight: 600;
  line-height: 30px;
}

.description-paragraph {
  color: #7e8596;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
}

img {
  width: 464px;
  height: 332px;
  object-fit: contain;
}
</style>



// WEBPACK FOOTER //
// src/modules/ml-studio/components/MlStudioTwoColSection.vue